<template>
  <div class="protocol-topic-detail-relative-model">
    <div class="relative-model-content">
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item style="float: right">
            <search-input
              :placeholder="$t('dms_topic_detail_relative_model.wmxmcwmxdm')"
              v-model="formSearch.search"
              @fetch="getTableList"
            ></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button
              :link="$refs.container"
              @click="onSwitchButtonClick"
            ></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container
        ref="container"
        @search="getTableList"
        @clear="clearFilter()"
      >
        <el-form
          :inline="true"
          label-position="top"
        >
          <el-form-item :label="$t('dms_topic_detail_relative_model.bu_jian')">
            <el-input v-model="formSearch.component"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_topic_detail_relative_model.fen_lei')">
            <el-input v-model="formSearch.dataGroup"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_topic_detail_relative_model.TCPdai_ma')">
            <el-input v-model="formSearch.tcpDataCode"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          ref="table"
          :data="tableList"
          :column="tableColumn"
          :height="tableHeight"
          @filter="filterChange"
          @sort="sortChange"
          :index="true"
          row-key="tslDataId"
          :tree-props="{ children: 'children' }"
          :slots="['transferExpression', 'dbUnit', 'tcpDataUnit']"
        >
          <!-- 存储单位 iot_tsl_data_unit db_ratio -->
          <template v-slot:dbUnit="scope">
            <span>{{ getStockUnit(scope.row) }}</span>
          </template>
          <!-- 协议单位 iot_tsl_data_unit tcp_data_ratio -->
          <template v-slot:tcpDataUnit="scope">
            <span>{{ getProtocolUnit(scope.row) }}</span>
          </template>
          <template v-slot:transferExpression="scope">
            <span v-if="scope.row.dataType !== 'Enum'">
              {{ scope.row.transferExpression }}
            </span>
            <el-button
              v-if="scope.row.dataType === 'Enum' && scope.row.transferType !== '0'"
              type="text"
              size="mini"
              @click="seeExpression(scope.row)"
            >{{ $t('dms_topic_detail_relative_model.cha_kan_xiang_qing') }}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>

    <expression-setting-dialog
      v-if="showExpression"
      @close="showExpression = false"
      :code="expressionCode"
      :expression="expression"
      :disabled="true"
      :model="dialogModel2"
    ></expression-setting-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';
import customTable from '@/components/customTable.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import expressionSettingDialog from '@/pages/dms/product/children/expression_setting_dialog.vue';
import mixins from './mixins';

export default {
  mixins: [resetFormSearchMixins, mixins],
  components: {
    customTable,
    expressionSettingDialog,
  },
  props: {
    // data: {
    //   type: Array,
    //   default() {
    //     return [];
    //   },
    // },
    topicId: String,
    protocolCode: String,
    tableHeight: {
      type: String,
      default: '400px'
    }
  },
  data() {
    return {
      tableCode: 'protocol_relative_model_detail',
      showExpression: false,
      expressionCode: '',
      expression: '',
      dialogModel2: {},
      formSearch: {
        search: '',
        pageSize: 30,
        pageNum: 1,
        component: '',
        dataGroup: '',
        tcpDataCode: '',
      },
      totalRows: null,
      tableList: [],
    };
  },
  mounted() {
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    onSwitchButtonClick() {
      // console.log('click');
      // this.tableList = [];
      // setTimeout(() => {
      //   // this.getTableList();
      //   this.$refs.table.$refs.tb1.doLayout();
      // }, 1000);
    },
    getReqData() {
      return {
        ...this.formSearch,
        topicId: this.topicId,
        protocolCode: this.protocolCode,
      };
    },
    seeExpression(row) {
      this.expressionCode = row.dicGroup;
      this.expression = row.transferExpression;
      this.dialogModel2.title = this.$t('dms_topic_detail_relative_model.zdzppb');
      this.showExpression = true;
    },
    fixProperty(list) {
      const fixArr = [
        'topicTslClass',
        'tcpDataCode',
        'topicTslType',
        'transferType',
        'transferExpression',
        'isPrimary',
        'isYearKey',
        'showOrder',
        'tcpDataLen',
        'curTag',
        'index',
        'tcpDataType',
        'isPushMq',
        'topicTslGroup',
      ];
      list.forEach((item) => {
        fixArr.forEach((key) => {
          if (item[key] === undefined) {
            if (key === 'transferType') {
              item[key] = '0';
            } else if (key === 'isPrimary') {
              item[key] = 0;
            } else if (key === 'isYearKey') {
              item[key] = 0;
            } else if (key === 'showOrder') {
              item[key] = 0;
            } else if (key === 'isPushMq') {
              item[key] = 0;
            } else {
              item[key] = '';
            }
          }
        });
      });
    },
    nodeToTree(list, pid) {
      if (pid === undefined) {
        pid = '0';
      }
      const ret = [];
      list.forEach((item) => {
        if (item.dataParentId === pid) {
          ret.push(item);
        }
      });
      ret.forEach((item) => {
        item.children = this.nodeToTree(list, item.tslDataId);
      });
      return ret;
    },
    getTableList() {
      this.$getJSON(apis.TslTopicAssociatedList, this.getReqData()).then((res) => {
        const list = res.data.list;
        this.fixProperty(list);
        // const { newData, oldData } = this.filterNewData(list);
        // this.addRecord(newData);
        // this.syncData(oldData, list);
        const treeNodes = this.nodeToTree(list);
        this.tableList = treeNodes;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
.protocol-topic-detail-relative-model {
  .relative-model-content {
    display: flex;
    flex-direction: column;
  }
  .el-table {
    margin-top: 0 !important;
  }
}
</style>
